import { autoDesignCandidateFilters } from "./autoDesignCandidateFilters";

// Only the engine can certify that a completed search rejected the selected
// inverter. Timeouts, offline responses and validation failures are not that.
export async function runWithInverterFallback(run, payload, params = {}) {
  try {
    return await run(payload);
  } catch (error) {
    const failure = error?.data?.detail;
    if (!payload.inverter || params.keepInverterModel || error?.status !== 422 ||
        failure?.inverter_replacement_allowed !== true || failure?.limit_hit) throw error;
    const replacement = {
      ...payload,
      ...autoDesignCandidateFilters(params, payload.module, null),
      inverter: undefined,
      preferred_inverter: payload.inverter,
    };
    const result = await run(replacement);
    return { ...result, inverterReplacement: {
      previous: payload.inverter, proposed: result.inverter || result.inverter_name,
      targetKw: payload.pv_capacity_kw,
    } };
  }
}

export function inverterReplacementMessage(change, greek) {
  if (!change?.previous || !change?.proposed || change.previous === change.proposed) return "";
  return greek
    ? `Με τον ${change.previous} δεν βρέθηκε συμβατή λύση για στόχο ${change.targetKw} kWp με τα επιλεγμένα όρια. Προτάθηκε ο ${change.proposed}. Η αλλαγή εφαρμόζεται με την αποθήκευση του σχεδίου.`
    : `No compatible design was found with ${change.previous} for the ${change.targetKw} kWp target within the selected limits. Proposed ${change.proposed}. Save the design to apply the change.`;
}
